import axios from "@/api/AuthAPI/auth-request-api";
import { auth } from "@/config/host.config";
import { AxiosResponse } from "axios";
import { IConsents } from "@/@types/filoxenia-config/consents";

export const ConsentsAPI = {
  getAll(
    match: Record<string, unknown> = {}
  ): Promise<AxiosResponse<IConsents[]>> {
    const params: Record<string, unknown> = {};
    Object.keys(match).forEach((key) => {
      const value = match[key];
      if (typeof value === "object" && value !== null) {
        Object.keys(value).forEach((subKey) => {
          params[`match[${key}][${subKey}]`] = (
            value as Record<string, unknown>
          )[subKey];
        });
      } else {
        params[`match[${key}]`] = value;
      }
    });
    return axios.get(`${auth.consents}/`, { params });
  },

  getById(id: string): Promise<AxiosResponse<IConsents>> {
    return axios.get(`${auth.consents}/${id}`);
  },

  add(body: Partial<IConsents>): Promise<AxiosResponse<IConsents>> {
    return axios.post(`${auth.consents}/`, body);
  },

  updateById(
    id: string,
    body: Partial<IConsents>
  ): Promise<AxiosResponse<IConsents>> {
    return axios.put(`${auth.consents}/${id}`, body);
  },

  deleteById(id: string): Promise<AxiosResponse<IConsents>> {
    return axios.delete(`${auth.consents}/${id}`);
  },

  forceDeleteById(id: string): Promise<AxiosResponse<void>> {
    return axios.delete(`${auth.consents}/force/${id}`);
  },

  restoreById(id: string): Promise<AxiosResponse<void>> {
    return axios.put(`${auth.consents}/restore/${id}`);
  },
};
